// Mapping de atributos crudos -> etiquetas amigables para UI
const FRIENDLY_LABELS: Record<string, string> = {
  temperatura: 'Temperatura (°C)',
  temperatura_nasa: 'Temperatura NASA (°C)',
  temperatura_device: 'Temperatura dispositivo (°C)',
  temperaturaDevice: 'Temperatura dispositivo (°C)',
  voltaje_device: 'Voltaje de batería (V)',
  voltajeDevice: 'Voltaje de batería (V)',
  voltajeBateria: 'Voltaje de batería (V)',
  conductividad: 'Conductividad (µS/cm)',
  turbidez: 'Turbidez (NTU)',
  salinidad: 'Salinidad',
  latitud: 'Latitud',
  longitud: 'Longitud',
  staleness: 'Staleness',
  freshness: 'Freshness',
};

export function friendlyAttrLabel(attr?: string): string {
  if (!attr) return '';
  // Normalizar claves conocidas que pueden venir en camelCase/snake
  const key = String(attr);
  if (FRIENDLY_LABELS[key] !== undefined) return FRIENDLY_LABELS[key];
  // Capitalizar primera letra por defecto
  return key.charAt(0).toUpperCase() + key.slice(1);
}
